import { Component, forwardRef, Renderer2, ViewChild, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CompanyService } from '../../../service/company/company.service';

export const EPANDED_TEXTAREA_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SelectCompanyComponent),
  multi: true,
};

@Component({
  selector: 'app-select-company',
  templateUrl: './select-company.component.html',
  styleUrls: ['./select-company.component.scss'],
  providers: [EPANDED_TEXTAREA_VALUE_ACCESSOR],
})
export class SelectCompanyComponent implements ControlValueAccessor {
    @Input() companyId: number;
    @ViewChild('input') textarea;

    public companiesOptions: any[];

    public onChange;
    public onTouched;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;
    public filters: {key: string, value: string}[];

    constructor(
        private renderer: Renderer2,
        public companyService: CompanyService
    ) {
        this.page = 1;
        this.per_page = 10;
        this.query = undefined;
        this.filters = [];
        this.filters.push({key: 'activated-lk', value: '1'});
        this.getCompanies(this.query, this.filters);
    }

    writeValue(value: any ) {
        const div = this.textarea.nativeElement;
        // this.renderer.setProperty(div, 'textContent', value);
    }

    registerOnChange(fn: any ) {
        this.onChange = fn;
    }

    registerOnTouched(fn: any ) {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean ) {
        const div = this.textarea.nativeElement;
        const action = isDisabled ? 'addClass' : 'removeClass';
        this.renderer[action](div, 'disabled');
    }

    public change($event) {
        this.onChange($event.target.value);
        this.onTouched($event.target.value);
    }

    getCompanies(query?: string, filters?: any[]) {
        this.companyService.getCompany(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
            response => {
                const companies = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }

                this.companiesOptions = [];
                this.companiesOptions.push({id: undefined, name: 'Choose'});
                companies.forEach(element => {
                    if (this.companyId === element.id) {
                        this.companiesOptions.push({id: element.id, name: element.name, selected: true});
                    } else {
                        this.companiesOptions.push({id: element.id, name: element.name, selected: false});
                    }
                });
            },
            error => {
                this.companiesOptions = [];
                this.companiesOptions.push({id: '', name: 'Error'});
            }
        );
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/companies/select-company/select-company.component.ts